export enum MODERATION_RESPONSE {
   CREATED = 'CREATED',
   EDITED = 'EDITED',
   REMOVED = 'REMOVED',
   DONE = 'DONE',
   ERROR = 'ERROR'
}
